import React from 'react';
import '../styles/components/StepIndicator.css';

const StepIndicator = ({
  currentIndex = 0,
  totalSteps = 1,
  onStepClick = () => {},
  className = '',
  clickableSteps = true,
}) => {
  if (totalSteps < 1) return null;

  return (
    <div className={`step-indicator ${className}`}>
      {Array.from({ length: totalSteps }).map((_, index) => {
        const isActive = index === currentIndex;

        return (
          <div
            key={index}
            className={`step-indicator__item ${
              isActive
                ? 'step-indicator__item--active'
                : 'step-indicator__item--inactive'
            }`}
            onClick={() => clickableSteps && onStepClick(index)}
          >
            {index + 1}
          </div>
        );
      })}
    </div>
  );
};

export default StepIndicator;
